import React from "react";
import { Field } from "./UI";

export function LauncherHeading({ icon, children }) {
  return (
    <span className="launcher-heading">
      <span className="launcher-heading-icon" aria-hidden="true">{icon}</span>
      {children}
    </span>
  );
}

export function ReadOnlyBadge({ label, id, value, fallback }) {
  const state = value === true ? "enabled" : value === false ? "disabled" : "unknown";
  const missing = value === undefined || value === null || value === "";
  const text = value === true ? "Enabled" : value === false ? "Disabled" : missing ? fallback : String(value);

  return (
    <Field label={label} htmlFor={id}>
      <output id={id} className={`launcher-badge launcher-badge-${state}`}>
        <span className="status-dot" aria-hidden="true" />{text}
      </output>
    </Field>
  );
}

export function LauncherSummary({ serverName, missionName, maxPlayers, installedMods, configFile }) {
  const items = [
    ["Server Name", serverName],
    ["Mission Name", missionName],
    ["Current Map", "Unknown"],
    ["Max Players", maxPlayers],
    ["Installed Mods", installedMods],
    ["Status", "Unavailable"]
  ];

  return (
    <section className="panel launcher-summary" aria-label="Launch summary">
      <div className="panel-body">
        <dl className="launcher-summary-grid">
          {items.map(([label, value]) => (
            <div key={label}>
              <dt>{label}</dt>
              <dd>{label === "Status"
                ? <span className="launcher-badge launcher-badge-unknown" title="Server status is not available on this page.">{value}</span>
                : value}</dd>
              {label === "Server Name" && (
                <div className="launcher-summary-config">Config File: <span>{configFile}</span></div>
              )}
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
